export default "__VITE_ASSET__981ffc8a__"